import React, { useState } from "react";

import BetItemTableHead from "./BetItemTableHead";
import BetDetails from "@features/my-bets/desktop/bet-details-page/item/BetDetails";
import BetOffers from "./BetOffers";

export default function BetItemTable(props: {
	toggleDetails: () => void;
	isDetailsDisplayed?: boolean;
	setShowCombinations: (value: boolean) => void;
}) {
	const [isPrinting, setIsPrinting] = useState(false);

	return (
		<table className="table--bets" cellSpacing={0} cellPadding={0}>
			<BetItemTableHead
				toggleDetails={props.toggleDetails}
				isDetailsDisplayed={props.isDetailsDisplayed}
				isPrinting={isPrinting}
				setIsPrinting={setIsPrinting}
			/>
			<tbody className="table--bets__body">
				<BetOffers />
				{(props.isDetailsDisplayed == true || isPrinting) && (
					<BetDetails
						setShowCombinations={props.setShowCombinations}
					/>
				)}
			</tbody>
		</table>
	);
}
